export default __webpack_public_path__ + "static/18-3fd54f9fd4f25cc2e8d01437fd5bbe22.webp";